import React, { useEffect, useRef } from 'react';
import { useAudioVideo } from 'amazon-chime-sdk-component-library-react';
import { VideoElement } from './style';

const ContentShareVideo = ({ tileId }) => {
  const audioVideo = useAudioVideo();
  const videoRef = useRef(null);

  useEffect(() => {
    if (!audioVideo || !videoRef.current || !tileId) {
      return () => {};
    }

    audioVideo.bindVideoElement(tileId, videoRef.current);

    return () => {
      try {
        audioVideo.unbindVideoElement(tileId);
      } catch (_e) {
        // Non-fatal.
      }
    };
  }, [audioVideo, tileId]);

  return <VideoElement ref={videoRef} autoPlay playsInline />;
};

export default ContentShareVideo;
